import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

interface SelectOption {
  label: string;
  value: number;
}

interface SelectRef {
  select?: {
    menuListRef?: {
      scrollTo: (x: number, y: number) => void;
    };
  };
}

interface SntOrganizationSelectorProps {
  value: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (value: SelectOption | null, actionMeta?: any) => void;
  items: SelectOption[];
  placeholder?: string;
}

const styles = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: (base: any) => ({
    ...base,
    minHeight: 34,
    border: "1px solid #b8bfca",
    boxShadow: "none",
    "&:hover, &:focus": {
      border: "1px solid #0071a1",
    },
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dropdownIndicator: (base: any) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearIndicator: (base: any) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

const SntOrganizationSelector: React.FC<SntOrganizationSelectorProps> = ({
  value,
  onChange,
  items,
  placeholder,
}) => {
  const [currentItems, setCurrentItems] = useState<SelectOption[]>(items);
  const index = useRef<number>(0);
  const searchText = useRef<string>("");
  const selectInput = useRef<SelectRef | null>(null);

  useEffect(() => {
    index.current = 0;
    if (items.length > 0) {
      setCurrentItems(
        items.slice(index.current * 50, index.current * 50 + 50 - 1)
      );
    }
  }, [items]);

  const getSearchTextItems = () => {
    return items.filter(
      (s) =>
        s.label.toLowerCase().indexOf(searchText.current.toLowerCase()) !== -1
    );
  };

  const onMenuScrollToBottom = () => {
    index.current = index.current + 1;
    setCurrentItems([
      ...currentItems,
      ...getSearchTextItems().slice(
        index.current * 50,
        index.current * 50 + 50 - 1
      ),
    ]);
  };

  const onInputChange = (text: string) => {
    index.current = 0;
    searchText.current = text;
    setCurrentItems(
      getSearchTextItems().slice(
        index.current * 50,
        index.current * 50 + 50 - 1
      )
    );

    if (selectInput.current?.select?.menuListRef) {
      selectInput.current.select.menuListRef.scrollTo(0, 0);
    }
  };

  return (
    <Select
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={(input) => (selectInput.current = input as any)}
      menuPosition={"fixed"}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onChange={onChange as any}
      options={currentItems}
      onInputChange={onInputChange}
      onMenuScrollToBottom={onMenuScrollToBottom}
      styles={styles}
      placeholder={placeholder}
      value={items.find((option) => option.value === value) || null}
      menuPlacement="auto"
    />
  );
};

export default SntOrganizationSelector;
